var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarP1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1663",
    "data-name": "Groupe 1663",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1666",
    "data-name": "Groupe 1666",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1665",
    "data-name": "Groupe 1665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_945",
    "data-name": "Trac\\xE9 945",
    d: "M22,3V5",
    transform: "translate(-14)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_946",
    "data-name": "Trac\\xE9 946",
    d: "M10,3V5",
    transform: "translate(6)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1664",
    "data-name": "Groupe 1664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_947",
    "data-name": "Trac\\xE9 947",
    d: "M21,11H5",
    transform: "translate(-1 -3)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1064",
    "data-name": "Trac\\xE9 1064",
    d: "M5.5,9.5V6.31a.787.787,0,0,1,.762-.81H20.738a.787.787,0,0,1,.762.81V21.69a.787.787,0,0,1-.762.81H5.5",
    transform: "translate(-1.5 -1.5)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1655",
    "data-name": "Groupe 1655",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1407",
    "data-name": "Groupe 1407",
    transform: "translate(6 10.22)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_6",
    "data-name": "Ligne 6",
    x1: 2,
    y2: 2,
    transform: "translate(1 -0.22)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_7",
    "data-name": "Ligne 7",
    x1: 2,
    y1: 2,
    transform: "translate(1 1.78)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2969",
    "data-name": "Trac\\xE9 2969",
    d: "M0,0H6",
    transform: "translate(7 12)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2970",
    "data-name": "Trac\\xE9 2970",
    d: "M0,0H4",
    transform: "translate(-1 12)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarP1);
export default __webpack_public_path__ + "static/media/calendar-p-1.49f546d35f7cd449e122f651a2393ef9.svg";
export { ForwardRef as ReactComponent };